// @flow
import React from 'react';
import { type CategoryData } from 'store/modules/common';
import cx from 'classnames';
import Circles from 'components/common/Loaders/Circles';
import CategoryMenuBoxItem from '../CategoryMenuBoxItem';
import './CategoryMenuBox.scss';

type Props = {
  categories: ?(CategoryData[]),
  history: Object,
  closeMenuBox: Function,
};

const CategoryMenuBox = ({ categories, history, closeMenuBox }: Props) => {
  if (categories) {
    const activeNav = document.querySelector(`span[class='active']`);
    const onMouseoverNav = e => {
      if (activeNav) {
        activeNav.classList.remove('active');
        e.target.classList.add('active');
      }
    };

    const alphabeticalCategory = categories.filter(doc => doc.order === 1);
    const subItemCategory = categories.filter(doc => doc.order === 2);

    const categoryA = alphabeticalCategory.filter(doc => doc.name === 'A')[0];

    const categoryNav = alphabeticalCategory.map(doc => {
      const active = doc.name === 'A';

      const lengthByCategory = subItemCategory.filter(docs => docs.parent === doc.id).length;

      return lengthByCategory ? (
        <span
          key={doc.id}
          id={doc.name}
          className={cx({ active })}
          onMouseOver={onMouseoverNav}
          onFocus={onMouseoverNav}
        >
          {doc.name}
        </span>
      ) : (
        <span key={doc.id} id={doc.name} className={'empty'}>
          {doc.name}
        </span>
      );
    });

    return (
      <div className="categoryMenuBox">
        <div className="nav-category">{categoryNav}</div>
        {activeNav ? (
          <div className="sub-category">
            {subItemCategory
              .filter(
                docs =>
                  docs.parent ===
                  alphabeticalCategory.filter(doc => doc.name === activeNav.textContent)[0].id,
              )
              .map((doc1, j) => (
                <CategoryMenuBoxItem
                  key={doc1.id}
                  name={doc1.name}
                  count={doc1.products_count}
                  history={history}
                  closeMenuBox={closeMenuBox}
                />
              ))}
          </div>
        ) : (
          <div className="sub-category">
            {subItemCategory
              .filter(docs => docs.parent === categoryA.id)
              .map((doc1, j) => (
                <CategoryMenuBoxItem
                  key={doc1.id}
                  name={doc1.name}
                  count={doc1.products_count}
                  history={history}
                  closeMenuBox={closeMenuBox}
                />
              ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="categoryLoadingMenuBox">
      <Circles color="blue" size="medium" />
    </div>
  );
};

export default CategoryMenuBox;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryMenuBox/CategoryMenuBox.js